document.addEventListener('DOMContentLoaded', function() {
  var buyButtonWrapper = document.querySelector('.buy-qty-wrapper');

  // Create a sticky wrapper and add it to the body
  var stickyWrapper = document.createElement('div');
  stickyWrapper.classList.add('sticky-buy-button-wrapper');

  // Clone the existing buy button wrapper without the ID
  var stickyBuyButtonWrapper = buyButtonWrapper.cloneNode(true);
  stickyBuyButtonWrapper.querySelector('.product__submit__item .btn').removeAttribute('id');
  stickyWrapper.appendChild(stickyBuyButtonWrapper);
  document.body.appendChild(stickyWrapper);

  // Hide the sticky button initially
  stickyWrapper.style.display = 'none';

  // Get the offset position of the original add-to-cart button
  var buyButtonOffsetTop = buyButtonWrapper.getBoundingClientRect().top + window.scrollY;

  // Intersection Observer to toggle visibility of sticky button when scrolling past the original button
  var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
          if (!entry.isIntersecting && window.scrollY > buyButtonOffsetTop) {
              // Show sticky button when original button is out of view and scrolled past its initial position
              stickyWrapper.style.display = 'block';
          } else {
              // Hide sticky button when original button is in view or scroll position is above it
              stickyWrapper.style.display = 'none';
          }
      });
  }, { threshold: 0 });

  // Observe the original button wrapper
  observer.observe(buyButtonWrapper);

  // Add event listener to the sticky button to scroll to the original add-to-cart button
  stickyBuyButtonWrapper.querySelector('.product__submit__item .btn').addEventListener('click', function(event) {
      event.preventDefault(); // Prevent default click behavior
      buyButtonWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
});
